import RfiAnalyticsTable from './RfiAnalyticsTable.component';

export default RfiAnalyticsTable;
